import { Typography, theme, Carousel } from "antd";
import { useRef } from "react";
import { NewsItem } from "./Sections.default";
import teamworkImg from "../../assets/images/teamwork.png";
import absenteeismImg from "../../assets/images/absenteeism.png";
import leadersImg from "../../assets/images/leaders.png";

const { Title, Paragraph } = Typography;

const newsItems: NewsItem[] = [
  {
    title: "Managing absenteeism",
    description:
      "This space is for an excerpt or preview of your main article. You can opt to simply add the first paragraph directly, or create a summary or teaser for it. Whatever you choose, don't give everything away! After all, you want them to read the full article.",
    image: absenteeismImg,
  },
  {
    title: "How to identify leaders",
    description:
      "This space is for an excerpt or preview of your main article. You can opt to simply add the first paragraph directly, or create a summary or teaser for it. Whatever you choose, don't give everything away! After all, you want them to read the full article.",
    image: leadersImg,
  },
  {
    title: "Teamwork",
    description:
      "This space is for an excerpt or preview of your main article. You can opt to simply add the first paragraph directly, or create a summary or teaser for it. Whatever you choose, don't give everything away! After all, you want them to read the full article.",
    image: teamworkImg,
  },
  {
    title: "How to identify leaders",
    description:
      "This space is for an excerpt or preview of your main article. You can opt to simply add the first paragraph directly, or create a summary or teaser for it. Whatever you choose, don't give everything away! After all, you want them to read the full article.",
    image: leadersImg,
  },
];

function SectionThree() {
  const { token } = theme.useToken();
  const carouselRef = useRef<any>(null);

  const getNewsItem = (index: number) => {
    const totalItems = newsItems.length;
    const safeIndex = ((index % totalItems) + totalItems) % totalItems;
    return newsItems[safeIndex];
  };

  const renderCard = ({
    index,
    item,
    size,
  }: {
    index: number;
    item: NewsItem;
    size: "middle" | "small" | "large";
  }) => {
    const isEven = index % 2 === 0;
    return (
      <div
        className={` ${size === "middle" ? "w-[44%]" : size === "small" ? "w-[28%]" : "w-[100%]"} ${size === "large" ? "mx-auto w-[80%]" : ""}`}
      >
        {isEven ? (
          <>
            <img
              src={item.image}
              alt={item.title}
              className="mb-4 h-[200px] w-full rounded-lg object-cover"
            />
            <Title level={2} style={{ color: "#1a1b4b" }}>
              {item.title}
            </Title>
            <Paragraph style={{ color: "#1a1b4b" }}>
              {item.description}
            </Paragraph>
          </>
        ) : (
          <>
            <Title level={2} style={{ color: "#1a1b4b" }}>
              {item.title}
            </Title>
            <Paragraph style={{ color: "#1a1b4b" }}>
              {item.description}
            </Paragraph>
            <img
              src={item.image}
              alt={item.title}
              className="mt-4 h-[200px] w-full rounded-lg object-cover"
            />
          </>
        )}
      </div>
    );
  };

  return (
    <section className="mx-16 my-6 rounded-xl bg-[#e5ebe5] px-6 py-6">
      {/* Title */}
      <Title
        level={1}
        className="mb-12 text-center text-4xl"
        style={{ color: "#1a1b4b", fontFamily: token.fontFamily }}
      >
        News Updates
      </Title>

      {/* Carousel */}
      <div className="relative">
        <Carousel
          ref={carouselRef}
          dots={false}
          arrows={true}
          slidesToShow={1}
          slidesToScroll={1}
        >
          {newsItems.map((_, index) => (
            <div key={index} className="px-4 lg:px-16">
              {/* Desktop Layout (3 columns) - Above 1024px */}
              <div className="hidden lg:flex lg:items-start lg:justify-between lg:gap-8">
                {renderCard({ index, item: getNewsItem(index), size: "small" })}
                {renderCard({
                  index: index + 1,
                  item: getNewsItem(index + 1),
                  size: "middle",
                })}
                {renderCard({
                  index: index + 2,
                  item: getNewsItem(index + 2),
                  size: "small",
                })}
              </div>

              {/* Tablet Layout (2 columns) - Between 640px and 1024px */}
              <div className="hidden px-8 sm:flex sm:items-start sm:justify-between sm:gap-8 lg:hidden">
                {renderCard({
                  index,
                  item: getNewsItem(index),
                  size: "middle",
                })}
                {renderCard({
                  index: index + 1,
                  item: getNewsItem(index + 1),
                  size: "middle",
                })}
              </div>

              {/* Mobile Layout (1 column) - Below 640px */}
              <div className="sm:hidden">
                <div className="mx-auto">
                  {renderCard({
                    index,
                    item: getNewsItem(index),
                    size: "large",
                  })}
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
}

export default SectionThree;
